import { render } from "./tuoshou.vue?vue&type=template&id=fe920b60"
import script from "./tuoshou.vue?vue&type=script&lang=js"
export * from "./tuoshou.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__